import React from "react";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { Chip } from "@material-ui/core";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import MaterialSwitch from "../../../styles/materialSwitch";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";

const TelegramDrainWalletsItem = ({ wallet, onActivated, onDelete, setNotification, t }) => {
  const handleActivate = () => {
    axios.patch(`/api/telegram/drain-wallets/${wallet.id}/activate`, {}, userAuthenticationConfig())
      .then(response => {
        if (response.status === 200) {
          setNotification({ visible: true, type: "success", message: t("drainWallets.success.activated") });
          onActivated();
        }
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("drainWallets.errors.activate") });
      });
  };

  return (
    <StyledTableRow scroll="auto" col="8">
      <StyledCol data-title={t("drainWallets.table.project")}>
        {wallet.projectName}
      </StyledCol>
      <StyledCol data-title={t("drainWallets.table.type")}>
        <Chip label={wallet.type} size="small" variant="outlined" />
      </StyledCol>
      <StyledCol data-title={t("drainWallets.table.network")}>
        <Chip label={`${wallet.currency || "USDT"} ${wallet.network || "TRC20"}`} size="small" color="primary" variant="outlined" />
      </StyledCol>
      <StyledCol data-title={t("drainWallets.table.label")}>
        {wallet.label}
      </StyledCol>
      <StyledCol inline data-title={t("drainWallets.table.address")}>
        <CopyToClipboard
          text={wallet.walletAddress}
          onCopy={() => setNotification({ visible: true, type: "success", message: t("common.copied") })}
        >
          <StyledBreakWord as="p">
            {wallet.walletAddress} <StyledCopy title={t("common.copy")} className="icon-light-copy" />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol data-title={t("drainWallets.table.status")}>
        <MaterialSwitch
          checked={wallet.isActive}
          onChange={handleActivate}
          label={t("drainWallets.table.status")}
        />
      </StyledCol>
      <StyledCol data-title={t("drainWallets.table.createdAt")}>
        {TimestampToDateMoment(wallet.createdAt)}
      </StyledCol>
      <StyledCol data-title={t("drainWallets.table.actions")}>
        <button className="table-action table-action_danger" onClick={() => onDelete(wallet.id)}>
          <span className="icon-light-trash" />
          {t("common.delete")}
        </button>
      </StyledCol>
    </StyledTableRow>
  );
};

export default TelegramDrainWalletsItem;
